import axios from "axios";

export const API_URL = process.env.REACT_APP_BACKEND_URL || "";

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("veedu_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Generic response data extractor
const extractData = (res) => res.data.data;

export const AuthAPI = {
  login: (credentials) => api.post("/api/Auth/login", credentials).then(extractData),
  logout: () => api.post("/api/Auth/logout").then(extractData),
  currentUser: () => api.get("/api/Auth/current-user").then(extractData),
};

export const UsersAPI = {
  getAll: () => api.get("/api/Users").then(extractData),
  getById: (id) => api.get(`/api/Users/${id}`).then(extractData),
  create: (user) => api.post("/api/Users", user).then(extractData),
  update: (id, user) => api.put(`/api/Users/${id}`, user).then(extractData),
  delete: (id) => api.delete(`/api/Users/${id}`).then(extractData),
  getRoles: () => api.get("/api/Users/roles").then(extractData),
};

export const CategoriesAPI = {
  getAll: () => api.get("/api/Categories").then(extractData),
  getById: (id) => api.get(`/api/Categories/${id}`).then(extractData),
  create: (category) => api.post("/api/Categories", category).then(extractData),
  update: (id, category) => api.put(`/api/Categories/${id}`, category).then(extractData),
  delete: (id) => api.delete(`/api/Categories/${id}`).then(extractData),
};

export const MenuAPI = {
  getAll: () => api.get("/api/menu-items").then(extractData),
  getById: (id) => api.get(`/api/menu-items/${id}`).then(extractData),
  getByCategory: (categoryId) => api.get(`/api/menu-items/category/${categoryId}`).then(extractData),
  create: (item) => api.post("/api/menu-items", item).then(extractData),
  update: (id, item) => api.put(`/api/menu-items/${id}`, item).then(extractData),
  delete: (id) => api.delete(`/api/menu-items/${id}`).then(extractData),
};

export const EventsAPI = {
  getAll: () => api.get("/api/Events").then(extractData),
  getById: (id) => api.get(`/api/Events/${id}`).then(extractData),
  create: (event) => api.post("/api/Events", event).then(extractData),
  update: (id, event) => api.put(`/api/Events/${id}`, event).then(extractData),
  delete: (id) => api.delete(`/api/Events/${id}`).then(extractData),

  getTags: () => api.get("/api/Events/tags").then(extractData),
  createTag: (tag) => api.post("/api/Events/tags", tag).then(extractData),
  updateTag: (id, tag) => api.put(`/api/Events/tags/${id}`, tag).then(extractData),
  deleteTag: (id) => api.delete(`/api/Events/tags/${id}`).then(extractData),
  assignTags: (eventId, tagIds) => api.post(`/api/Events/${eventId}/tags`, { eventId, tagIds }).then(extractData),
};

export const GalleryAPI = {
  getAll: (section) => api.get(section ? `/api/Gallery?section=${section}` : "/api/Gallery").then(extractData),
  getById: (id) => api.get(`/api/Gallery/${id}`).then(extractData),
  create: (item) => api.post("/api/Gallery", item).then(extractData),
  update: (id, item) => api.put(`/api/Gallery/${id}`, item).then(extractData),
  delete: (id) => api.delete(`/api/Gallery/${id}`).then(extractData),
};

export const UploadAPI = {
  uploadFile: (file, folder = "general") => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(`/api/Upload?folder=${folder}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(extractData);
  },
};

export const DashboardAPI = {
  getStats: () => api.get("/api/Dashboard/stats").then(extractData),
};

export const resolveImageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;

  const isLocal = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  const baseUrl = API_URL || (isLocal ? "https://localhost:7134" : "https://api.chefjomonsveedu.co.uk");

  return `${baseUrl}${path.startsWith('/') ? path : '/' + path}`;
};

export default api;
